import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Star, Clock, ChevronLeft, Plus, Minus, ShoppingBag } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { Button } from '../components/ui/button';

import { API } from '../config';

const RestaurantMenu = () => {
  const { id } = useParams();
  const nav = useNavigate();
  const { items, addItem, removeItem, total } = useCart();
  const [rest, setRest] = useState(null);
  const [menu, setMenu] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const r = await axios.get(`${API}/restaurants/${id}`);
        setRest(r.data.restaurant);
        setMenu(r.data.menu);
      } catch (e) { /* ignore */ }
    };
    load();
  }, [id]);

  const getQty = (mid) => items.find(i => i.id === mid)?.qty || 0;
  const cartCount = items.reduce((s,i)=>s+i.qty,0);

  if (!rest) return <div className="text-center py-20 text-gray-500">Loading menu...</div>;

  return (
    <div className="max-w-5xl mx-auto px-4 py-6 pb-24">
      <button onClick={()=>nav(-1)} className="flex items-center gap-1 text-sm text-gray-500 hover:text-tp-orange mb-3">
        <ChevronLeft size={16} /> Back
      </button>

      <div className="bg-white rounded-xl border border-gray-100 card-shadow p-5 flex flex-col md:flex-row gap-4">
        <div className="w-full md:w-48 h-36 bg-gray-100 rounded-lg overflow-hidden flex-shrink-0">
          <img src={rest.image} alt={rest.name} className="w-full h-full object-cover" />
        </div>
        <div className="flex-1">
          <h1 className="text-2xl font-bold text-[#0B2E5C]">{rest.name}</h1>
          <div className="text-sm text-gray-500">{rest.cuisines?.join(', ')}</div>
          <div className="flex flex-wrap items-center gap-3 mt-3 text-sm">
            <span className="flex items-center gap-1 bg-green-600 text-white px-2 py-0.5 rounded text-xs"><Star size={12} fill="white" /> {rest.rating}</span>
            <span className="flex items-center gap-1 text-gray-600"><Clock size={14} /> {rest.time}</span>
            <span className="text-gray-600">Min order ₹{rest.minOrder}</span>
          </div>
          <div className="text-xs text-gray-400 mt-2">FSSAI Lic: {rest.fssai} • Station: {rest.station}</div>
        </div>
      </div>

      <h2 className="text-lg font-bold text-[#0B2E5C] mt-6 mb-3">Menu</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {menu.map(m => {
          const qty = getQty(m.id);
          return (
            <div key={m.id} className="bg-white rounded-xl border border-gray-100 p-4 card-shadow flex gap-3">
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <span className={`inline-block w-4 h-4 border-2 ${m.veg ? 'border-green-600' : 'border-red-600'} bg-white`}>
                    <span className={`block w-1.5 h-1.5 rounded-full ${m.veg ? 'bg-green-600' : 'bg-red-600'} m-auto mt-[3px]`} />
                  </span>
                  <h3 className="font-semibold text-[#0B2E5C]">{m.name}</h3>
                </div>
                <div className="text-sm font-bold text-[#0B2E5C] mt-1">₹{m.price}</div>
                <p className="text-xs text-gray-500 mt-1">{m.desc}</p>
              </div>
              <div className="flex flex-col items-end justify-between">
                {m.image && <div className="w-24 h-24 rounded-lg overflow-hidden bg-gray-100"><img src={m.image} alt={m.name} className="w-full h-full object-cover" /></div>}
                {qty === 0 ? (
                  <Button onClick={()=>addItem(rest, m)} size="sm" className="mt-2 bg-white text-tp-orange border-2 border-tp-orange hover:bg-[#FFF3E6] font-bold">
                    <Plus size={14} className="mr-1" /> ADD
                  </Button>
                ) : (
                  <div className="mt-2 flex items-center gap-1 border-2 border-tp-orange rounded-md overflow-hidden">
                    <button onClick={()=>removeItem(m.id)} className="px-2 py-1 text-tp-orange hover:bg-[#FFF3E6]"><Minus size={14} /></button>
                    <span className="px-2 font-bold text-tp-orange">{qty}</span>
                    <button onClick={()=>addItem(rest, m)} className="px-2 py-1 text-tp-orange hover:bg-[#FFF3E6]"><Plus size={14} /></button>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {cartCount > 0 && (
        <div className="fixed bottom-4 left-0 right-0 flex justify-center z-40">
          <button onClick={()=>nav('/cart')} className="bg-tp-orange text-white font-bold px-6 py-3 rounded-xl shadow-2xl flex items-center gap-3 hover:bg-[#E07A0F]">
            <ShoppingBag size={18} />
            <span>{cartCount} items • ₹{total}</span>
            <span className="text-xs opacity-80">VIEW CART →</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default RestaurantMenu;
